export default __webpack_public_path__ + "2fdc08605740eacead41b28eab4c65d5.webp";